import { render, staticRenderFns } from "./AccidentData.vue?vue&type=template&id=1529564c&"
import script from "./AccidentData.vue?vue&type=script&lang=js&"
export * from "./AccidentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports